import { BlogPost } from '../blog';

import { EventsPost } from './post';

export default function Post() {
  const post = EventsPost();

  return <BlogPost {...post} />;
}
